export default {
  path: "kasse",
  name: "posWorkspace",
  component: () => import(/* webpackChunkName: "pos-workspace" */ "@/views/dashboard/pos/PosWorkspace.vue"),
  meta: { displayedTitle: "Kasse", rights: ["cassa_admin"] },
  children: [
    {
      path: "einstellungen",
      name: "posAccountSettings",
      component: () => import(/* webpackChunkName: "pos-workspace" */ "@/views/dashboard/pos/PosAccountSettings.vue"),
      meta: { displayedTitle: "Kassen-Einstellungen", rights: ["cassa_admin"] },
    },
    {
      path: "",
      redirect: { name: "posSale" },
      meta: { rights: ["cassa_admin"] },
    },
    {
      path: "verkauf",
      name: "posSale",
      component: () => import(/* webpackChunkName: "pos-workspace" */ "@/views/dashboard/pos/PosSale.vue"),
      meta: { displayedTitle: "Kasse", rights: ["cassa_admin"] },
    },
    {
      path: "gutscheine",
      name: "posVouchers",
      component: () => import(/* webpackChunkName: "pos-workspace" */ "@/views/dashboard/pos/PosVouchers.vue"),
      meta: { displayedTitle: "Gutscheine", rights: ["cassa_admin"] },
    },
    {
      path: "belege",
      name: "posReceipts",
      component: () => import(/* webpackChunkName: "pos-workspace" */ "@/views/dashboard/pos/PosReceipts.vue"),
      meta: { displayedTitle: "Vorgänge", rights: ["cassa_admin"] },
    },
    {
      path: "berichte",
      name: "posReports",
      component: () => import(/* webpackChunkName: "pos-workspace" */ "@/views/dashboard/pos/PosReports.vue"),
      meta: { displayedTitle: "Übersicht", rights: ["cassa_admin"] },
    },
    {
      path: "artikel",
      name: "posCatalog",
      component: () => import(/* webpackChunkName: "pos-workspace" */ "@/views/dashboard/pos/PosCatalog.vue"),
      meta: { displayedTitle: "Artikel", rights: ["cassa_admin"] },
    },
    {
      path: "geraete",
      name: "posDevices",
      component: () => import(/* webpackChunkName: "pos-workspace" */ "@/views/dashboard/pos/PosDevices.vue"),
      meta: { displayedTitle: "Kassengeräte", rights: ["cassa_admin"] },
    },
    {
      path: "online-gutschein",
      name: "posOnlineVoucher",
      redirect: { name: "posVouchers" },
      meta: { rights: ["cassa_admin"] },
    },
  ],
}
